/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector3dPb } from "../eigen_lcm/Vector3d";

export const protobufPackage = "shape_map";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface HalfPlanePb {
  add: boolean;
  point: Vector3dPb | undefined;
  planeUnitNormal: Vector3dPb | undefined;
}

function createBaseHalfPlanePb(): HalfPlanePb {
  return { add: false, point: undefined, planeUnitNormal: undefined };
}

export const HalfPlanePb = {
  encode(message: HalfPlanePb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.add === true) {
      writer.uint32(8).bool(message.add);
    }
    if (message.point !== undefined) {
      Vector3dPb.encode(message.point, writer.uint32(18).fork()).ldelim();
    }
    if (message.planeUnitNormal !== undefined) {
      Vector3dPb.encode(message.planeUnitNormal, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HalfPlanePb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHalfPlanePb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.add = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.point = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.planeUnitNormal = Vector3dPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HalfPlanePb {
    return {
      add: isSet(object.add) ? globalThis.Boolean(object.add) : false,
      point: isSet(object.point) ? Vector3dPb.fromJSON(object.point) : undefined,
      planeUnitNormal: isSet(object.planeUnitNormal) ? Vector3dPb.fromJSON(object.planeUnitNormal) : undefined,
    };
  },

  toJSON(message: HalfPlanePb): unknown {
    const obj: any = {};
    if (message.add === true) {
      obj.add = message.add;
    }
    if (message.point !== undefined) {
      obj.point = Vector3dPb.toJSON(message.point);
    }
    if (message.planeUnitNormal !== undefined) {
      obj.planeUnitNormal = Vector3dPb.toJSON(message.planeUnitNormal);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HalfPlanePb>, I>>(base?: I): HalfPlanePb {
    return HalfPlanePb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HalfPlanePb>, I>>(object: I): HalfPlanePb {
    const message = createBaseHalfPlanePb();
    message.add = object.add ?? false;
    message.point = (object.point !== undefined && object.point !== null)
      ? Vector3dPb.fromPartial(object.point)
      : undefined;
    message.planeUnitNormal = (object.planeUnitNormal !== undefined && object.planeUnitNormal !== null)
      ? Vector3dPb.fromPartial(object.planeUnitNormal)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
